<template>
  <div>
    <v-row justify="center">
      <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition" @keydown.esc="avisoCerrar"
        persistent>
        <v-card tile>
          <v-toolbar flat dark color="primary">
            <v-btn icon dark @click="avisoCerrar">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>
              <span v-if="parte.numParte !== null">
                {{ parte.numParte }} -
              </span>
              <span>
                {{ parte.cliente }}
              </span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <!-- FACTURACION DESHABILITADO DE MOMENTO!!!! -->
              <!--EN V-IF PARA DESHABILITAR facturarDisponible && -->
              <!-- <v-btn dark text @click="guardarYFacturarParte" v-if="parte.estadoParte_id == 4 && !parte.bloqueado"
                :disabled="soloLectura || !parte.esEditable">
                Facturar
              </v-btn> -->
              <v-btn dark text @click="guardar"
                :disabled="guardadoDeshabilitado || soloLectura || !(!parte.esEditable || tienePermisosEnComponenteId(11) || tienePermisosEnComponenteId(14))">
                Guardar
              </v-btn>
            </v-toolbar-items>
            <v-menu bottom right offset-y> </v-menu>
          </v-toolbar>
          <v-alert class="mt-4 ml-6 mr-6" dense outlined border="left" type="warning" icon="mdi-alert-outline"
            v-if="estadoParteActual == 5">
            Este parte ya está facturado y no se puede editar.
          </v-alert>
          <v-alert class="mt-4 ml-6 mr-6" dense outlined border="left" type="warning" icon="mdi-alert-outline"
            v-else-if="!parte.esEditable">
            No tienes permisos para editar este parte.
          </v-alert>
          <v-alert class="mt-4 ml-6 mr-6" dense outlined border="left" type="error" icon="mdi-close-circle-outline"
            v-if="this.$refs.resumen && this.$refs.resumen.estadoContrato() === 'critico'">
            {{ parte.cliente }} tiene contratos en negativo que se encuentran
            por encima del umbral máximo
          </v-alert>
          <v-alert class="mt-4 ml-6 mr-6" dense outlined border="left" type="info" icon="mdi-alert-circle-outline"
            v-if="this.$refs.resumen && this.$refs.resumen.estadoContrato() === 'leve'">
            {{ parte.cliente }} tiene contratos en negativo
          </v-alert>
          <v-alert class="mt-4 ml-6 mr-6" dense outlined border="left" type="info" icon="mdi-information-outline"
            v-if="parte.obsCliente && parte.obsCliente !== ''">
            Observaciones del cliente: {{ parte.obsCliente }}
          </v-alert>

          <v-card-text>
            <v-card class="mt-4">
              <v-tabs v-model="tabs" fixed-tabs>
                <v-tabs-slider></v-tabs-slider>
                <v-tab>
                  <v-icon left>mdi-file-document-outline</v-icon>
                  Detalles
                </v-tab>

                <v-tab>
                  <v-icon left>mdi-account-box-outline</v-icon>
                  Datos parte
                </v-tab>

                <v-tab>
                  <v-icon left>mdi-cart-outline</v-icon>
                  Materiales
                </v-tab>

                <v-tab :disabled="$v.parte.delegacion_id.$invalid">
                  <v-icon left>mdi-chart-arc</v-icon>
                  Resumen
                </v-tab>

                <v-tab>
                  <v-icon left>mdi-email-send-outline</v-icon>
                  Informe y comunicaciones
                </v-tab>

                <!-- Detalles -->
                <v-tab-item>
                  <v-card flat>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" sm="12" md="6">
                          <v-text-field v-model="parte.concepto" label="Concepto" maxlength="35" counter
                            :disabled="!parte.esEditable"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field label="Trello asociado" v-model="parte.urlTrello"
                            :disabled="soloLectura || !parte.esEditable"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="2" class="d-flex">
                          <v-btn :href="parte.urlTrello" target="_blank" outlined color="primary"
                            class="align-self-center" :style="adaptarBoton" :disabled="parte.urlTrello === null || parte.urlTrello === '' || !parte.esEditable
                              " block>
                            <v-icon class="mr-1"> mdi-trello </v-icon>
                            Abrir Trello
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-textarea label="A realizar" v-model="parte.realizar" @input="$v.parte.realizar.$touch()"
                            @blur="$v.parte.realizar.$touch()" :error-messages="errorRealizar"
                            :readonly="soloLectura || !parte.esEditable" class="anadirAsterisco"></v-textarea>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-textarea label="Observaciones" v-model="parte.observaciones"
                            :readonly="soloLectura || !parte.esEditable"></v-textarea>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="4" md="4">
                          <v-autocomplete v-model="parte.responsable_id" :items="tecnicos" chips
                            color="blue-grey lighten-2" label="Responsable de cuenta" item-text="name" item-value="id"
                            @input="$v.parte.responsable_id.$touch()" @blur="$v.parte.responsable_id.$touch()"
                            :error-messages="errorResponsableParte" :disabled="soloLectura || !parte.esEditable"
                            class="anadirAsterisco">
                            <template v-slot:selection="data">
                              <v-chip v-bind="data.attrs" :input-value="data.selected">
                                <v-avatar left :color="data.item.color">
                                  <span class="white--text">{{
                                    data.item.avatar
                                  }}</span>
                                </v-avatar>
                                {{ data.item.name + " " + data.item.apellidos }}
                              </v-chip>
                            </template>
                            <template v-slot:item="data">
                              <template>
                                <v-list-item-avatar :color="data.item.color">
                                  <span class="white--text">{{
                                    data.item.avatar
                                  }}</span>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                  <v-list-item-title>{{
                                    data.item.name
                                  }}</v-list-item-title>
                                  <v-list-item-subtitle>{{
                                    data.item.apellidos
                                  }}</v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </template>
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                          <v-autocomplete v-model="parte.user_id" :items="tecnicos" chips color="blue-grey lighten-2"
                            label="Técnico asignado" item-text="name" item-value="id" @input="$v.parte.user_id.$touch()"
                            @blur="$v.parte.user_id.$touch()" :error-messages="errorTecnicoParte"
                            :disabled="soloLectura || !parte.esEditable" class="anadirAsterisco">
                            <template v-slot:selection="data">
                              <v-chip v-bind="data.attrs" :input-value="data.selected">
                                <v-avatar left :color="data.item.color">
                                  <span class="white--text">{{
                                    data.item.avatar
                                  }}</span>
                                </v-avatar>
                                {{ data.item.name + " " + data.item.apellidos }}
                              </v-chip>
                            </template>
                            <template v-slot:item="data">
                              <template>
                                <v-list-item-avatar :color="data.item.color">
                                  <span class="white--text">{{
                                    data.item.avatar
                                  }}</span>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                  <v-list-item-title>{{
                                    data.item.name
                                  }}</v-list-item-title>
                                  <v-list-item-subtitle>{{
                                    data.item.apellidos
                                  }}</v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </template>
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                          <v-autocomplete v-model="parte.comercial_id" :items="comerciales" chips
                            color="blue-grey lighten-2" label="Comercial asignado" item-text="name" item-value="id"
                            @input="$v.parte.comercial_id.$touch()" @blur="$v.parte.comercial_id.$touch()"
                            :error-messages="errorComercialParte" :disabled="soloLectura || !parte.esEditable"
                            class="anadirAsterisco">
                            <template v-slot:selection="data">
                              <v-chip v-bind="data.attrs" :input-value="data.selected">
                                <v-avatar left :color="data.item.color">
                                  <span class="white--text">{{
                                    data.item.avatar
                                  }}</span>
                                </v-avatar>
                                {{ data.item.name + " " + data.item.apellidos }}
                              </v-chip>
                            </template>
                            <template v-slot:item="data">
                              <template>
                                <v-list-item-avatar :color="data.item.color">
                                  <span class="white--text">{{
                                    data.item.avatar
                                  }}</span>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                  <v-list-item-title>{{
                                    data.item.name
                                  }}</v-list-item-title>
                                  <v-list-item-subtitle>{{
                                    data.item.apellidos
                                  }}</v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </template>
                          </v-autocomplete>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <!-- Datos parte -->
                <v-tab-item>
                  <v-card flat>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" :sm="parte.numPedido ? 6 : 10">
                          <v-select v-model="parte.delegacion_id" label="Delegación" :items="delegaciones"
                            item-text="direccion" item-value="delegacionId" @input="$v.parte.delegacion_id.$touch()"
                            @blur="$v.parte.delegacion_id.$touch()" :error-messages="errorDelegacion"
                            :disabled="soloLectura || !parte.esEditable" class="anadirAsterisco">
                            <template slot="selection" slot-scope="data">
                              {{ data.item.direccion }} - {{ data.item.city }}
                            </template>
                            <template slot="item" slot-scope="data">
                              {{ data.item.direccion }} - {{ data.item.city }}
                            </template>
                          </v-select>
                        </v-col>
                        <v-col v-if="parte.numPedido" cols="12" sm="4">
                          <v-text-field label="Número de pedido" :value="parte.numPedido" disabled></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2" align-self="center">
                          <v-btn class="mr-4" color="primary" outlined @click="dialogCambiarCliente = true"
                            :disabled="guardadoDeshabilitado || soloLectura || !parte.esEditable" block>
                            Cambiar cliente
                          </v-btn>
                        </v-col>
                        <CambiarCliente v-model="dialogCambiarCliente" v-if="dialogCambiarCliente"
                          @confirmar="cambiarCliente" :comercial_id="parte.comercial_id" :tecnico_id="parte.user_id"
                          :acciones="parte.acciones" :cliente="{
                            cliente_id: parte.cliente_id,
                            cliente_nombre: parte.cliente,
                          }" :delegacion="delegaciones.find(
  (delegacion) =>
    delegacion.delegacionId === parte.delegacion_id
)
  " :tipoParte_id="parte.tipoParte_id" :tipoParte_contrato="contratos.find(
    (contrato) => contrato.id === parte.tipoParte_id
  )
    " />
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="3">
                          <v-dialog ref="dialogFecha" v-model="modalFecha" :return-value.sync="parte.fecha" persistent
                            width="290px">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field v-model="parte.fechaFormateada" prepend-icon="mdi-calendar" label="Fecha"
                                v-bind="attrs" v-on="on" @blur="
                                  parte.fecha = parseDate(parte.fechaFormateada)
                                  " readonly :disabled="soloLectura || !parte.esEditable"></v-text-field>
                            </template>
                            <v-date-picker v-model="parte.fecha" scrollable :first-day-of-week="1">
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="modalFecha = false">Cancelar</v-btn>
                              <v-btn text color="primary" @click="$refs.dialogFecha.save(parte.fecha)">Aceptar</v-btn>
                            </v-date-picker>
                          </v-dialog>
                        </v-col>
                        <v-col cols="12" sm="3">
                          <v-dialog ref="dialogHoraInicioParte" v-model="modalHoraInicioParte"
                            :return-value.sync="parte.inicio" persistent width="290px">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field v-model="parte.inicio" prepend-icon="mdi-clock-outline" label="Hora" readonly
                                v-bind="attrs" v-on="on" :disabled="soloLectura || !parte.esEditable"></v-text-field>
                            </template>
                            <v-time-picker v-if="modalHoraInicioParte" v-model="parte.inicio" format="24hr" full-width>
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="modalHoraInicioParte = false">Cancelar</v-btn>
                              <v-btn text color="primary" @click="
                                $refs.dialogHoraInicioParte.save(parte.inicio)
                                ">Aceptar</v-btn>
                            </v-time-picker>
                          </v-dialog>
                        </v-col>
                        <v-col cols="12" sm="3">
                          <v-dialog ref="dialogFechaVto" v-model="modalFechaVto" :return-value.sync="parte.fechaVto"
                            persistent width="290px">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field v-model="parte.fechaVtoFormateada" prepend-icon="mdi-calendar"
                                label="Fecha vto." v-bind="attrs" v-on="on" @blur="
                                  parte.fechaVto = parseDate(
                                    parte.fechaVtoFormateada
                                  )
                                  " readonly :disabled="soloLectura || !parte.esEditable"></v-text-field>
                            </template>
                            <v-date-picker v-model="parte.fechaVto" scrollable :first-day-of-week="1">
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="modalFechaVto = false">Cancelar</v-btn>
                              <v-btn text color="primary" @click="
                                $refs.dialogFechaVto.save(parte.fechaVto)
                                ">Aceptar</v-btn>
                            </v-date-picker>
                          </v-dialog>
                        </v-col>
                        <v-col cols="12" sm="3">
                          <v-text-field prepend-icon="mdi-timer-outline" label="Horas estimadas"
                            v-model="parte.horasEstimadas" type="number" :min="0"
                            :readonly="!authUser.isAdmin"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-textarea label="Observaciones internas" v-model="parte.obsInternas"
                            :readonly="soloLectura || !parte.esEditable"></v-textarea>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-select v-model="parte.fidelizar" label="Fidelización" :items="fidelizacion"
                            item-text="nombre" item-value="valor"
                            :disabled="existenFidelizaciones || soloLectura || !parte.esEditable"></v-select>
                          <v-alert dense outlined border="left" type="warning" icon="mdi-alert-outline"
                            v-if="existenFidelizaciones">
                            Las fidelizaciones no se pueden desactivar cuando
                            existen acciones de fidelización creadas
                          </v-alert>
                        </v-col>
                      </v-row>
                      <v-divider></v-divider>
                      <v-row>
                        <v-col cols="12"
                          :sm="parteFacturado && authUser.isAdmin || parte.estadoParte_id == 4 && !parte.bloqueado ? 9 : 12">
                          <v-select v-model="parte.estadoParte_id" label="Estado del parte"
                            :items="estadosParteDisponibles" item-text="estado" item-value="id"
                            :disabled="soloLectura || !parte.esEditable">
                            <template v-slot:selection="data">
                              <v-chip :color="data.item.color" outlined small>
                                {{ data.item.estado }}
                              </v-chip>
                            </template>
                          </v-select>
                          <v-alert dense outlined border="left" type="info" icon="mdi-information-outline"
                            v-if="$v.parte.fidelizaciones.$invalid">
                            Existen acciones de fidelización pendientes de
                            finalizar, por lo que no están disponibles todos los
                            estados del parte
                          </v-alert>
                        </v-col>
                        <v-col v-if="parteFacturado && authUser.isAdmin" cols="12" md="3" align-self="center">
                          <v-btn color="primary" outlined @click="desfacturarParte()" :disabled="false" block>
                            Desfacturar parte
                          </v-btn>
                        </v-col>
                        <v-col v-else-if="parte.estadoParte_id == 4 && !parte.bloqueado"
                          :disabled="soloLectura || !parte.esEditable" cols="12" md="3" align-self="center">
                          <v-btn color="primary" outlined @click="dialogConsultarFacturarHorasAunqueSeaPptoCerrado = true"
                            :disabled="guardadoDeshabilitado || soloLectura || !parte.esEditable" block>
                            Facturar
                          </v-btn>
                        </v-col>
                        <!-- <v-btn dark text @click="guardarYFacturarParte" v-if="parte.estadoParte_id == 4 && !parte.bloqueado"
                          :disabled="soloLectura || !parte.esEditable">
                          Facturar
                        </v-btn> -->
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-select v-if="authUser.isAdmin" v-model="parte.tipo_parte" label="Restricción de contrato"
                            :items="contratosActivos" item-text="contrato" item-value="id"
                            :disabled="soloLectura || !parte.esEditable" return-object clearable></v-select>
                        </v-col>
                      </v-row>
                      <v-divider></v-divider>
                      <v-row v-if="authUser.isAdmin">
                        <v-col cols="12">
                          <p class="font-weight-medium">
                            Opciones avanzadas
                          </p>
                          <v-btn color="error" class="ma-2" outlined @click="confirmacionBorrado()">
                            <v-icon left dark>
                              mdi-file-remove-outline
                            </v-icon>
                            Eliminar parte
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <!-- Materiales -->
                <v-tab-item>
                  <materiales :parte="parte"></materiales>
                </v-tab-item>
                <!-- Resumen -->
                <v-tab-item :eager="true">
                  <v-card flat>
                    <v-card-text>
                      <resumen v-bind:contratos="contratos" v-bind:ambitos="ambitos"
                        v-bind:gradosUrgencia="gradosUrgencia" v-bind:usuarios="usuarios" v-bind:parte="parte"
                        v-bind:acciones="parte.acciones" v-bind:delegacion_id="parte.delegacion_id"
                        v-bind:delegaciones="delegaciones" v-bind:resumenParte="true" ref="resumen" />
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <!-- Informe y comunicaciones -->
                <v-tab-item>
                  <v-card flat>
                    <v-card-text>
                      <informe-comunicaciones v-bind:parte="parte" v-bind:guardadoDeshabilitado="guardadoDeshabilitado" />
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs>
            </v-card>
            <acciones v-bind:parte="parte" v-bind:contratos="contratos" v-bind:ambitos="ambitos"
              v-bind:gradosUrgencia="gradosUrgencia" v-bind:usuarios="usuarios" v-bind:tecnicos="tecnicos"
              v-bind:clientes="clientes" v-bind:guardadoDeshabilitado="guardadoDeshabilitado" :delegaciones="delegaciones"
              :headersPartes="headersPartes" />
            <fidelizaciones v-bind:parte="parte" v-bind:usuarios="usuarios" v-if="parte.fidelizar" />
          </v-card-text>
          <div style="flex: 1 1 auto"></div>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogCerrar" persistent max-width="380">
        <v-card>
          <v-card-title class="headline">¡Atención!</v-card-title>
          <v-card-text>Vas a salir sin guardar los cambios. ¿Estás seguro?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogCerrar = false">Cancelar</v-btn>
            <v-btn color="error" text @click="cerrar">Salir</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogSolicitudDesbloqueo" persistent max-width="380">
        <v-card>
          <v-card-title class="headline">Solicitud de desbloqueo</v-card-title>
          <v-card-text>
            {{ usuarioSolicitud }} está solicitando abrir este parte.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="cancelarSolicitudDesbloqueo"> Cancelar </v-btn>
            <v-btn color="success" text @click="aceptarSolicitudDesbloqueo">
              <v-progress-circular :value="countdown" size="18" rotate="270" color="info"
                class="mx-1"></v-progress-circular>
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <BaseConfirmDelete v-model="dialogConfirmarEliminarParte" message="Vas a eliminar este parte. ¿Estás seguro?"
        confirm-text="Eliminar" @confirm="borarParte($event)" />

      <v-dialog v-model="dialogConsultarFacturarHorasAunqueSeaPptoCerrado" persistent max-width="380">
        <v-card>
          <v-card-title class="headline">¿Quieres facturar las horas de las acciones?</v-card-title>
          <v-checkbox class="mt-0 ml-5" v-model="facturarHorasAunqueSeaPptoCerrado"
            label="Facturar las horas de acciones" />
          <!-- <v-card-text class="info--text" v-if="parte.tipoParte_id === 7 && facturarHorasAunqueSeaPptoCerrado">
            ⚠️ El pedido está marcado como Ppto. Cerrado. Es posible que al marcar esta opción las horas facturadas no
            coincidan con las presupuestadas.</v-card-text> -->
          <v-alert class="body-2 mx-2" dense outlined border="left" type="info" icon="mdi-alert-outline"
            v-if="parte.tipoParte_id === 7 && facturarHorasAunqueSeaPptoCerrado">
            Pedido marcado como Ppto. Cerrado.
            <br>
            Es posible que al marcar esta opción las horas facturadas no
            coincidan con las presupuestadas.
          </v-alert>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogConsultarFacturarHorasAunqueSeaPptoCerrado = false"> Cancelar </v-btn>
            <v-btn color="success" text @click="guardarYFacturarParte">
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import Acciones from "./Acciones";
import Fidelizaciones from "./Fidelizaciones";
import Resumen from "./Resumen";
import Materiales from "./Materiales";
import InformeComunicaciones from "./InformeComunicaciones";
import CambiarCliente from "./CambiarCliente";
import { required, sameAs } from "vuelidate/lib/validators";
import formatDate from "@/mixins/formatearFecha";
import parseDate from "@/mixins/formatearFecha";
import getArrayPositionByItemId from "@/mixins/getArrayPositionByItemId";
import axios from "axios";
import Echo from "laravel-echo";
// import io from "socket.io-client";
import uuidv4 from "../../mixins/uuidv4";
import BaseConfirmDelete from "../../components/utils/BaseConfirmDelete";

axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_API_URL;

export default {
  name: "FullDialogParte",
  mixins: [formatDate, parseDate, getArrayPositionByItemId, uuidv4],
  props: [
    "parte",
    "contratos",
    "delegaciones",
    "ambitos",
    "gradosUrgencia",
    "estadosParte",
    "usuarios",
    "tecnicos",
    "clientes",
    "comerciales",
    "headersPartes",
    // "guardadoDeshabilitado",
  ],
  data() {
    return {
      // facturarDisponible: false,
      dialogConfirmarEliminarParte: false,
      dialogCerrar: false,
      dialogSolicitudDesbloqueo: false,
      usuarioSolicitud: null,
      tabs: null,
      modalHoraInicioParte: false,
      modalFecha: false,
      modalFechaVto: false,
      countdown: 100,
      intervalCountdownAnimation: null,
      intervalCountdown: null,
      acciones: [],
      eventoCierre: null,
      fidelizacion: [
        {
          valor: 0,
          nombre: "Desactivada",
        },
        {
          valor: 1,
          nombre: "Activa",
        },
      ],
      estadoParteActual: null,
      dialogCambiarCliente: false,
      dialogConsultarFacturarHorasAunqueSeaPptoCerrado: false,
      facturarHorasAunqueSeaPptoCerrado: false
    };
  },
  validations: {
    parte: {
      realizar: { required },
      user_id: { required },
      responsable_id: { required },
      comercial_id: { required },
      delegacion_id: { required },
      estadoParte_id: { required },
      fidelizaciones: {
        $each: {
          estado: {
            finalizado: sameAs(() => true),
          },
        },
      },
    },
    // materialSelected: { required },
  },
  methods: {
    ...mapActions({
      guardarParte: 'acciones/guardarParte',

    }),
    ...mapActions("partes", ["setDialog"]),
    ...mapActions(["setLoading", "setSnackbar"]),
    avisoCerrar() {
      this.dialogCerrar = true;
    },
    async cerrar() {
      this.setLoading(true);
      if (this.parte.id !== undefined) {
        // Si no es un parte nuevo
        await this.desbloquearParte();
      }
      this.dialogCerrar = false;
      this.setDialog(false);
      this.setLoading(false);
    },
    async desbloquearParte() {
      if (!this.parte.bloqueado) {
        // Nota: el parte cuando se abre se recibe como no bloqueado pero imediatamente después se marca como bloqueado en base de datos
        // Al cerrar el parte, debe avisar al servidor para que lo marque como desbloqueado
        // En el caso de recibirlo como bloqueado es porque otro usuario lo tenía abierto, por lo que no tiene que marcarlo como desbloqueado al salir
        try {
          let respuesta = await axios.patch(`/api/partes/${this.parte.id}`);
          console.log(respuesta);
        } catch (error) {
          this.setSnackbar({
            tipo: "error",
            mensaje:
              "Error. No se ha podido desbloquear el parte, ponte en contacto con el administrador de la aplicación",
          });
        }
      }
    },
    cambiarCliente(event) {
      this.parte.cliente_id = event.cliente.value;
      this.parte.cliente = event.cliente.text;
      this.parte.delegacion_id = event.delegacionId;
      this.parte.user_id = event.user_id;
      this.parte.comercial_id = event.comercial_id;
      this.parte.tipoParte_id = event.tipoParte_id;
      this.parte.accionesModificadas = event.acciones;
      // this.delegaciones = event.delegaciones;
      this.guardar();
      // this.cerrar();
    },
    async guardar() {
      this.setLoading(true);
      //con getter no iba
      const materialesRequest = await this.$store.dispatch('materiales/getMaterialesRequest')
      this.parte.materiales = materialesRequest
      // if (this.materialesIniciales.length || this.materiales.length) this.parte.materiales = this.materiales;
      await this.guardarParte(true);
      this.setDialog(false);
      this.setLoading(false);
    },
    async guardarYFacturarParte() {
      try {
        // if (this.materialesIniciales.length || this.materiales.length) this.parte.materiales = this.materiales;
        //con getter no iba
        const materialesRequest = await this.$store.dispatch('materiales/getMaterialesRequest')
        this.parte.materiales = materialesRequest
        this.setLoading(true);
        await this.guardarParte()
        this.facturarParte();
      } catch (error) {
        this.setLoading(false);
        this.setSnackbar({
          tipo: "error",
          mensaje: "Error. No se han podido guardar los datos para facturar",
        });
      }
    },
    facturarParte() {
      let respuesta = axios
        .post(`/api/partes/${this.parte.id}/facturar?horas=${this.facturarHorasAunqueSeaPptoCerrado}`)
        .then((response) => {
          const numDocumento = response.data;
          let mensaje;
          if (typeof (numDocumento) == 'string') {
            const isPedido = response.data.includes("PV");
            mensaje = isPedido
              ? `Pedido ${numDocumento} editado correctamente.`
              : `Factura ${numDocumento} creada correctamente.`;
          }
          else mensaje = 'No hay nada que facturar, se ha marcado el parte como facturado.'
          this.setDialog(false);
          this.setSnackbar({
            tipo: "success",
            mensaje: mensaje,
          });
        })
        .catch((error) => {
          console.log(error.response);
          let mensaje = error.response.data.error
            ? error.response.data.error
            : error.response.data.message &&
              error.response.data.message.split("#").length > 1
              ? error.response.data.message.split("#")[1]
              : `Se ha producido un error al facturar el parte.`;

          this.setSnackbar({
            tipo: "error",
            mensaje: mensaje,
          });
        })
        .finally(() => {
          this.setLoading(false);
        });
    },
    async aceptarSolicitudDesbloqueo() {
      this.setLoading(true);
      this.dialogSolicitudDesbloqueo = false;
      this.detenerCountdown();
      this.guardar();
      try {
        await axios.get(
          `/api/respuestasolicitarparte/${this.parte.id}?respuesta=1`
        );
      } catch (error) {
        this.setSnackbar({
          tipo: "error",
          mensaje: "Error. No se ha podido enviar la solicitud",
        });
        this.setLoading(false);
      }
    },
    async cancelarSolicitudDesbloqueo() {
      this.setLoading(true);
      try {
        await axios.get(
          `/api/respuestasolicitarparte/${this.parte.id}?respuesta=0`
        );
      } catch (error) {
        this.setSnackbar({
          tipo: "error",
          mensaje: "Error. No se ha podido enviar la solicitud",
        });
      }
      this.dialogSolicitudDesbloqueo = false;
      this.detenerCountdown();
      this.setLoading(false);
    },
    async iniciarCountdown() {
      // Countdown de 20 segundos
      this.intervalCountdownAnimation = setInterval(() => {
        // this.iniciarCountdown();
        if (this.countdown > 0) {
          this.countdown -= 15;
        }
      }, 1000);
      this.intervalCountdown = setTimeout(() => {
        this.aceptarSolicitudDesbloqueo();
      }, 7500);
    },
    detenerCountdown() {
      clearInterval(this.intervalCountdownAnimation);
      clearInterval(this.intervalCountdown);
      this.countdown = 100;
    },
    desfacturarParte() {
      this.parte.estadoParte_id = 4;
      this.estadoParteActual = this.parte.estadoParte_id;
      this.parte.desfacturarParte = 1;
    },
    confirmacionBorrado() {
      this.dialogConfirmarEliminarParte = true;
    },
    borarParte() {
      console.log("Borrar");
      this.setLoading(true);
      axios.delete(`/api/partes/${this.parte.id}`).then(() => {
        this.setDialog(false);
        this.setSnackbar({
          tipo: "success",
          mensaje: "Parte eliminado correctamente",
        });
      }).catch((error) => {
        console.log(error);
        this.setSnackbar({
          tipo: "error",
          mensaje: "Error. No se ha podido eliminar el parte",
        });
      }).finally(() => {
        this.setLoading(false);
      });
    }
  },
  computed: {
    ...mapState("partes", ["dialog"]),
    ...mapState("login", ["authUser"]),
    ...mapGetters({
      tienePermisosEnComponenteId: "login/tienePermisosEnComponenteId",
      //   headersMateriales: "headersMateriales",
    }),
    adaptarBoton() {
      if (this.$vuetify.breakpoint.md) {
        return "width: 145px;";
      }
    },
    errorRealizar() {
      if (this.$v.parte.realizar.$dirty) {
        if (this.$v.parte.realizar.$invalid) {
          return "Introduce las tareas a realizar del parte";
        }
      }
    },
    errorResponsableParte() {
      if (this.$v.parte.responsable_id.$dirty) {
        if (this.$v.parte.responsable_id.$invalid) {
          return "Introduce el responsable de cuenta del parte";
        }
      }
    },
    errorTecnicoParte() {
      if (this.$v.parte.user_id.$dirty) {
        if (this.$v.parte.user_id.$invalid) {
          return "Introduce el técnico asignado al parte";
        }
      }
    },
    errorComercialParte() {
      if (this.$v.parte.comercial_id.$dirty) {
        if (this.$v.parte.comercial_id.$invalid) {
          return "Introduce el comercial asignado al parte";
        }
      }
    },
    errorDelegacion() {
      if (this.$v.parte.delegacion_id.$dirty) {
        if (this.$v.parte.delegacion_id.$invalid) {
          return "Introduce la delegación";
        }
      }
    },
    fecha() {
      return this.parte.fecha;
    },
    fechaVto() {
      return this.parte.fechaVto;
    },
    existenFidelizaciones() {
      return this.parte.fidelizaciones.length > 0;
    },
    guardadoDeshabilitado() {
      if (
        this.$v.parte.realizar.$invalid ||
        this.$v.parte.user_id.$invalid ||
        this.$v.parte.comercial_id.$invalid ||
        this.$v.parte.delegacion_id.$invalid ||
        this.$v.parte.responsable_id.$invalid
      ) {
        return true;
      }
      return false;
    },
    estadosParteDisponibles() {
      // Si existen acciones pendientes de fidelizar y no están finalizadas, únicamente devuelve los estados Activo y Pdte. fidelizar
      // Un parte con acciones pendientes de fidelizar no puede cambiar de estos estados hasta que estén todas marcadas como finalizadas.
      if (this.$v.parte.fidelizaciones.$invalid) {
        //Si el estado del parte es diferente de 1 (activo), 2 (Pdte. Fidelizar) cambia el estado a 2(Pdte. Fidelizar)
        if (
          this.parte.estadoParte_id !== 1 &&
          this.parte.estadoParte_id !== 2 &&
          this.parte.estadoParte_id !== 6 //estado previo a activo
        ) {
          this.parte.estadoParte_id = 2;
        }
        return this.estadosParte.filter(
          (item) => item.id === 1 || item.id === 2 || item.id === 6
        );
      }
      return this.estadosParte;
    },
    soloLectura() {
      return this.estadoParteActual == 5 || this.parte.bloqueado;
    },
    parteFacturado() {
      if (this.parte.estadoParte_id === 5) {
        return true;
      }
      return false;
    },
    contratosActivos() {
      return this.contratos.filter((contrato) => contrato.activo === true);
    },
  },
  created() {
    // Controlar el cierre o recarga de la página
    this.eventoCierre = (event) => {
      this.guardar();
      this.cerrar();
      event.returnValue = "";
    };
    window.addEventListener("beforeunload", this.eventoCierre);
  },
  mounted() {
    // window.io = io;
    // window.Echo = new Echo({
    //   broadcaster: "socket.io",
    //   host: process.env.VUE_APP_SOCKET_IO,
    // });
    // window.Echo.channel("ardipartes_database_channel-partes").listen(
    //   "SolicitarParte",
    //   (data) => {
    //     console.log("--------->");
    //     console.log(data);
    //     if (parseInt(data.id) === this.parte.id) {
    //       this.usuarioSolicitud =
    //         this.usuarios[
    //           this.getArrayPositionByItemId(
    //             this.usuarios,
    //             data.idUsuarioSolicitud
    //           )
    //         ].name;
    //       this.dialogSolicitudDesbloqueo = true;
    //     }
    //   }
    // );
    // this.setMaterialesIniciales();

    // console.log('mounted full dialog');
    if (this.parte.id !== undefined) {
      this.estadoParteActual = this.parte.estadoParte_id;
      this.facturarHorasAunqueSeaPptoCerrado = this.parte.tipoParte_id !== 7
    }
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.eventoCierre);
  },
  destroyed() {
    // window.Echo.leave("ardipartes_database_channel-partes");
    // Si por URL se envía el id del parte eliminamos el parámetro de la url
    if (this.$route.params.id) {
      this.$router.push({ name: "partes" });
    }
  },
  watch: {
    fecha() {
      this.parte.fechaFormateada = this.formatDate(this.parte.fecha);
    },
    fechaVto() {
      this.parte.fechaVtoFormateada = this.formatDate(this.parte.fechaVto);
    },
    dialogSolicitudDesbloqueo() {
      if (this.dialogSolicitudDesbloqueo) {
        this.iniciarCountdown();
      } else {
        this.detenerCountdown();
      }
    },
    'parte.tipo_parte'() {
      if (this.parte.tipo_parte) {
        this.parte.tipoParte_id = this.parte.tipo_parte.id;
      } else {
        this.parte.tipoParte_id = undefined;
      }
    }
  },
  components: {
    acciones: Acciones,
    fidelizaciones: Fidelizaciones,
    resumen: Resumen,
    materiales: Materiales,
    "informe-comunicaciones": InformeComunicaciones,
    CambiarCliente,
    BaseConfirmDelete
  },
};
</script>

<style>
.anadirAsterisco label::after {
  content: " *";
  color: red;
}
</style>